import {
  postExternalUser,
  postLogin,
  postLogout,
  postVerifyEmail,
} from "../../api";
import { createSliceWithThunks } from "../utils";

const initialState = {
  activeSession: localStorage.getItem("activeSession")
    ? JSON.parse(localStorage.getItem("activeSession"))
    : null,
  login: {
    data: null,
    status: "idle",
    error: null,
  },
  verifyEmail: {
    data: null,
    status: "idle",
    error: null,
  },
  register: {
    data: null,
    status: "idle",
    error: null,
  },
};

export const authSlice = createSliceWithThunks({
  name: "auth",
  initialState: initialState,
  reducers: (create) => ({
    resetStateAuth: create.reducer((state, { payload }) => {
      if (payload) {
        for (let key in payload) {
          state[`${payload[key]}`] = initialState[`${payload[key]}`];
        }
      } else {
        for (let key in initialState) {
          state[key] = initialState[key];
        }
      }
    }),
    logout: create.reducer((state) => {
      state.activeSession = null;
      localStorage.clear();
      window.location.replace("/");
      localStorage.removeItem("activeSession");
    }),
    setActiveSession: create.reducer((state, { payload }) => {
      localStorage.setItem("activeSession", JSON.stringify(payload));
      window.location.href = window.location.href;
    }),
    //* thunks
    verifyEmail: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await postVerifyEmail(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.verifyEmail.status = "loading";
        },
        rejected: (state, action) => {
          state.verifyEmail.status = "failed";
          state.verifyEmail.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.verifyEmail.error = { message: respObj };
            } else if (status === "success") {
              state.verifyEmail.data = respObj;
            }
          } else {
            state.verifyEmail.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.verifyEmail.status = "idle";
        },
      }
    ),
    userLogin: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await postLogin(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.login.status = "loading";
        },
        rejected: (state, action) => {
          state.login.status = "failed";
          state.login.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.login.error = { message: respObj };
            } else if (status === "success") {
              // localStorage.setItem("activeSession", JSON.stringify(respObj));
              // state.activeSession = respObj;
              state.login.data = respObj;
              state.login.error = null;
            }
          } else {
            state.login.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.login.status = "idle";
        },
      }
    ),

    userLogOut: create.asyncThunk(
      async ({ rejectWithValue }) => {
        try {
          const response = await postLogout();
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {},
        rejected: (state, action) => {
          state.login.status = "failed";
          state.login.error = action.error;
        },
        fulfilled: (state, { payload }) => {},
      }
    ),

    registerExternalUser: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await postExternalUser(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.register.status = "loading";
        },
        rejected: (state, action) => {
          state.register.status = "failed";
          state.register.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.register.error = { message: respObj };
            } else if (status === "success") {
              state.register.data = respObj;
            }
          } else {
            state.register.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.register.status = "idle";
        },
      }
    ),
  }),
});

export const {
  resetStateAuth,
  verifyEmail,
  userLogin,
  userLogOut,
  logout,
  registerExternalUser,
  setActiveSession,
} = authSlice.actions;
export default authSlice.reducer;
